import { Alert, Col, DatePicker, Form, List, Row, Space, Input } from 'antd';
import LocaleContext from 'locales';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import UserSearch from 'components/UserSearch';
import { OwnDesktops, RequestInfo, TimePreset } from './components';
import FormItemApprovalLine from './components/FormItemApprovalLine';

function DesktopDelete(props) {
  const { id, type, form, setIsWaitState, isCreate, detailData, onFinishDetail, backConf } = props;

  // hooks
  const { locale } = useContext(LocaleContext);

  const [userSearchNamePath, setUserSearchNamePath] = useState(undefined); // UserSearch를 설정할 폼의 네임 패스

  const [selectedVd, setSelectedVd] = React.useState([]);

  useEffect(() => {
    if (!id) {
      form.resetFields();
      const applicant = localStorage.getItem('userId');

      form.setFieldsValue({
        applicant,
        type: 'approval.types.delete-vd',
      });
      return;
    }
    if (detailData) {
      let approveDate = detailData?.approveDate;
      if (approveDate && !moment.isMoment(approveDate)) {
        approveDate = moment(new Date(approveDate));
      }
      form.setFieldsValue({
        ...detailData,
        user: detailData.user,
        approveDate,
        applyDate: moment(detailData.applyDate).format('YYYY-MM-DD HH:mm:ss'),
      });

      if (setIsWaitState) {
        setIsWaitState(detailData.state === 'approval.state.waiting');
      }
    }
  }, [id, detailData]);

  const onFinish = async ({ approveDate, ...fields }) => {
    const payload = {
      ...fields,
      user: fields.user,
      contents: selectedVd,
      approveDate: approveDate?.format('YYYY-MM-DD HH:mm') || approveDate,
    };
    onFinishDetail(payload);
  };

  // 사용자 선택되었을 때
  const onUserSearchSelected = (selectedUser) => {
    // 선택 취소면 아무것도 안한다.
    if (!selectedUser) {
      setUserSearchNamePath(undefined);
      return;
    }
    const result = { [userSearchNamePath]: selectedUser.sAMAccountName };
    form.setFieldsValue(result);
    setUserSearchNamePath(undefined);
  };

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 19 }}
      onFinish={onFinish}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Alert
            showIcon
            type="warning"
            message={
              <List
                size="small"
                split={false}
                dataSource={[
                  locale.resource['txt.check-download-to-local'],
                  locale.resource['txt.download-data-before-request'],
                ]}
                renderItem={(item) => <List.Item style={{ padding: 4 }}>{item}</List.Item>}
              />
            }
          />
        </Col>
        <Col span={24}>
          <RequestInfo readOnly={!isCreate} />
          <Form.Item label={locale.resource['txt.approval-type']} name="type" required>
            {locale.resource['txt.delete-vd']}
          </Form.Item>
          <Form.Item label={locale.resource['txt.user-and-id']} required>
            <Row gutter={[0, 4]}>
              <Col span={24}>
                <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Form.Item
                    noStyle
                    name="user"
                    rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
                  >
                    <Input.Search
                      readOnly
                      disabled={!isCreate}
                      onSearch={() => setUserSearchNamePath(['user'])}
                    />
                  </Form.Item>
                  <UserSearch visible={userSearchNamePath} onSelected={onUserSearchSelected} />
                </Space>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item
            label={locale.resource['txt.deleted-vd']}
            name="contents"
            valuePropName="contents"
            required
            rules={[
              { required: selectedVd.length === 0, message: locale.resource['txt.required-field'] },
            ]}
          >
            <OwnDesktops
              readOnly={!isCreate}
              user={detailData?.user || form.getFieldValue('user')}
              apprType={type}
              onSelect={(record) => {
                setSelectedVd(record);
              }}
              requestId={id}
              // contents={form.getFieldValue('contents')}
            />
          </Form.Item>
          <Form.Item
            label={locale.resource['txt.execution-date']}
            name="approveDate"
            extra={locale.resource['txt.excution-date-msg']}
            rules={[
              () => ({
                validator(_, value) {
                  if (value > moment() || !value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(locale.resource['txt.excution-date-val']));
                },
              }),
            ]}
            initialValue={null} // #193685
          >
            <DatePicker
              showTime={{
                defaultValue: moment('00:00', 'HH:mm'),
                format: 'HH:mm',
              }}
              inputReadOnly={1}
              disabled={!isCreate}
              placeholder=""
              disabledDate={(date) => date && date < moment().startOf('day')}
              showNow={false}
              format="YYYY-MM-DD HH:mm"
              renderExtraFooter={() => (
                <TimePreset
                  onSelect={(time) => {
                    form.setFieldsValue({ approveDate: time });
                  }}
                />
              )}
            />
          </Form.Item>
          <FormItemApprovalLine isCreate={isCreate} form={form} backConf={backConf} type={type} />
        </Col>
      </Row>
    </Form>
  );
}

export default DesktopDelete;
